var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "15px",
    viewBox: "0 0 20 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "80C2A7D0-2F48-4C16-B5EA-6A70BF89E7B0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Approved-Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location-existing-flow-3e",
    transform: "translate(-577.000000, -476.000000)",
    fill: "#9B9B9B",
    fillRule: "nonzero",
    stroke: "#9B9B9B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(368.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(20.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 256.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input-box"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.000000, 0.000000)",
    id: "Group-39"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "envelope",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8025979,0.293012772 L2.20111603,0.293012772 C0.986964042,0.293012772 0,1.27551314 0,2.48417398 L0,11.7382152 C0,12.946876 0.986964042,13.9293764 2.20111603,13.9293764 L15.7988735,13.9293764 C17.0130255,13.9293764 18,12.946876 18,11.7382152 L18,2.48788153 C18.0037139,1.27922069 17.0167498,0.293012772 15.8025979,0.293012772 Z M16.9981279,11.7382152 C16.9981279,12.3944513 16.4618153,12.9283383 15.8025979,12.9283383 L2.20111603,12.9283383 C1.54189854,12.9283383 1.00558601,12.3944513 1.00558601,11.7382152 L1.00558601,2.48788153 C1.00558601,1.83164543 1.54189854,1.29775843 2.20111603,1.29775843 L15.7988735,1.29775843 C16.458091,1.29775843 16.9944035,1.83164543 16.9944035,2.48788153 L16.9944035,11.7382152 L16.9981279,11.7382152 Z",
    id: "Shape",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9734316,7.08891812 L14.6713939,3.74581533 C14.8434649,3.5881218 14.8591077,3.3200428 14.7026795,3.14342605 C14.5462514,2.96996317 14.2803234,2.95419382 14.1051239,3.11188734 L9.00556504,7.72599997 L8.01068179,6.83030073 C8.00755323,6.82714686 8.00442466,6.82399299 8.00442466,6.82083912 C7.98252472,6.79876203 7.96062477,6.7798388 7.93559626,6.76091558 L3.88723484,3.10873347 C3.71203527,2.95103995 3.44610736,2.9668093 3.28967917,3.14342605 C3.13325099,3.3200428 3.14889381,3.5881218 3.32409337,3.74581533 L7.06585555,7.11730295 L3.33973619,10.6338686 C3.17079375,10.794716 3.16140806,11.062795 3.32096481,11.2362579 C3.40543603,11.3245663 3.51806432,11.3718743 3.63069261,11.3718743 C3.73393522,11.3718743 3.83717782,11.3340279 3.91852047,11.258335 L7.70095398,7.6913074 L8.72712288,8.61539147 C8.80846553,8.68793049 8.90857957,8.72262307 9.00869361,8.72262307 C9.10880765,8.72262307 9.21205025,8.68477662 9.29026434,8.6122376 L10.3445903,7.65976869 L14.1051239,11.2614889 C14.1864665,11.3403356 14.2928377,11.3781821 14.3960803,11.3781821 C14.5087086,11.3781821 14.6182083,11.3340279 14.7026795,11.2457195 C14.8622363,11.0754105 14.8559792,10.8041776 14.6870367,10.6433302 L10.9734316,7.08891812 Z",
    id: "Path",
    strokeWidth: 0.2
  }))))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.43740fe948a955a7e85e05722128f8c1.svg";
export { ForwardRef as ReactComponent };